<mat-card class="min-w-[25rem] max-w-[37.5rem]">
  <mat-card-content class="flex flex-col gap-y-3 text-body-large">
    <div class="text-headline-large">Success!</div>
    @let copy = organizationSelectors.copyOverrides | select;
    @let customMessage = forLookupContext ? undefined : copy?.REGISTRATION_CONFIRMATION_MESSAGE;
    @if (customMessage) {
      <p class="whitespace-pre-line break-words">{{ customMessage }}</p>
    } @else {
      <p>Welcome to {{ organizationSelectors.name | select }}. You now have full access to digital resources as well as our extensive collection of books, DVDs,
        CDs and more!</p>
      @if (!forLookupContext) {
        <p>Don’t forget to stop by your local branch to pick up your permanent card!</p>
      }
    }
    <p>What would you like to do first?</p>
    <mx-filled-button label="Browse Catalog" routeName="CATALOG" class="mt-8 mb-4"/>
    <mx-outlined-button label="View Account" routeName="DASHBOARD"/>
  </mat-card-content>
</mat-card>
